import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import App from './App';
import * as serviceWorker from './serviceWorker';
import { registerLicense } from '@syncfusion/ej2-base';

registerLicense('Ngo9BigBOggjHTQxAR8/V1NCaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXdcc3RcQ2FZUkVxV0Y=');

Sentry.init({
  dsn: "https://8b6f3adb08a843c7ac3b6ad980bec5a4@o1025753.ingest.sentry.io/4503925435138048",
  integrations: [new BrowserTracing()],
  tracesSampleRate: 0.1,
  // Off for local development, including production builds served from localhost
  enabled: process.env.NODE_ENV === 'production' && !['localhost', '127.0.0.1'].includes(window.location.hostname),
});
// document.getElementById('root')
createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
